// types
import dayjs from 'dayjs';
import { TotalActionsEntry } from './OpenRequests.types';

export const countTotalActions = (entries: TotalActionsEntry[]): number => {
  return entries.reduce((total, entry) => {
    const dailyTotal = entry.days.reduce(
      (sum, day) => sum + (day.totalNumberOfActions || 0),
      0
    );
    return total + dailyTotal;
  }, 0);
};

export const formatDatePair = (
  date: string | Date | undefined,
  subtractDays = 0
) => {
  const d = dayjs(date).subtract(subtractDays, 'day');
  return {
    short: d.format('DD MMM'),
    full: d.format('D MMMM YYYY')
  };
};
